import { Component } from '@angular/core';
import { CONTService } from './cont.service';

@Component({
  selector: 'contact-form',
  templateUrl: './contact-form.component.html',
  providers: [CONTService]
})
export class ContactFormComponent {
  public model = {
    text: "",
    enabled: true,
    cont: {
      cont_name: "",
      cont_stadt: "",
      cont_telefon: "",
      cont_handy: "",
      cont_email: "",
      cont_nachricht: ""
    }
  };

  private svc: CONTService;
  private errorMessage: any;

  constructor(svc: CONTService) {
    this.svc = svc;

    this.initialize();
  }

  public initialize(): void {

    //$http.defaults.useXDomain = true;
    //delete $http.defaults.headers.common['X-Requested-With'];

    this.model.text = "";

    var result = this.svc.newCONT();

    result.subscribe(
      content => this.model.cont = content.json(),
      error => this.errorMessage = <any>error);
  }

  public addCONT(): void {

    this.model.enabled = false;
    var result = this.svc.addCont(this.model.cont);

    result.subscribe(
      content => {
        this.model.text = "Nachricht wurde gesendet!";
        this.model.enabled = true;
      },
      error => alert(error),
    );

  }

}

